import { Controller } from "@hotwired/stimulus"

// Select2 на <select data-controller="select2"> — выбор из списка с поиском.
// jQuery и плагин грузятся лениво (динамический import), та же копия jQuery,
// что и у month-picker (esbuild --alias:jquery), чтобы не плодить отдельный
// bundle jQuery на страницах без select2.
export default class extends Controller {
  async connect() {
    const $ = await ensureSelect2()
    if (!this.element.isConnected) return // отключился, пока грузили

    const $select = $(this.element)
    $select.select2({
      theme: "bootstrap-5",
      width: "100%",
      placeholder: $select.find("option[value='']").first().text() || "Выберите значение",
      allowClear: true,
      language: {
        noResults: () => "Ничего не найдено",
        searching: () => "Поиск..."
      }
    })

    $select.on("select2:select select2:unselect", () => {
      this.element.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }

  disconnect() {
    if (!window.jQuery) return
    const $select = window.jQuery(this.element)
    if ($select.data("select2")) $select.select2("destroy")
  }
}

// Однократная ленивая загрузка jQuery + select2 + bootstrap-5 темы.
let select2Promise = null
function ensureSelect2() {
  select2Promise ||= (async () => {
    const jquery = (await import("jquery")).default
    window.$ = window.jQuery = jquery
    const select2 = (await import("select2")).default
    select2(jquery)
    return jquery
  })()
  return select2Promise
}
